import React, { useState } from 'react';
import useNFC from '../hooks/useNFC';
import { validateGridPosition } from '../services/nfcService';
import './NFCScanHandler.css';

function NFCScanHandler({ onPositionRead, gridConfig }) {
  const { available, scanning, scan, error, clearError } = useNFC();
  const [validationError, setValidationError] = useState(null);

  const handleScan = async () => {
    setValidationError(null);
    clearError();

    const position = await scan();
    if (!position) {
      return;
    }

    const result = validateGridPosition(position.row, position.col, gridConfig);
    if (!result.valid) {
      setValidationError(result.error);
      return;
    }

    onPositionRead(position.row, position.col);
  };

  if (!available) {
    return null;
  }

  return (
    <div className="nfc-scan-handler">
      <button
        className="nfc-scan-handler__btn"
        onClick={handleScan}
        disabled={scanning}
        aria-label="Scan NFC Tag"
      >
        {scanning ? 'Scanning...' : 'Scan NFC Tag'}
      </button>

      {scanning && (
        <p className="nfc-scan-handler__status" role="status">
          Hold your device near an NFC tag...
        </p>
      )}

      {error && (
        <p className="nfc-scan-handler__error" role="alert">
          {error}
        </p>
      )}

      {validationError && (
        <p className="nfc-scan-handler__error" role="alert">
          {validationError}
        </p>
      )}
    </div>
  );
}

export default NFCScanHandler;
